import { fetchAuthSession as amplifyFetchAuthSession } from 'aws-amplify/auth'

type AuthSession = Awaited<ReturnType<typeof amplifyFetchAuthSession>>

const CACHE_TTL_MS = 5 * 60 * 1000

let cachedSession: AuthSession | null = null
let cachedAt = 0
let inflightRequest: Promise<AuthSession> | null = null

const isCacheValid = (): boolean => {
  return cachedSession !== null && (Date.now() - cachedAt) < CACHE_TTL_MS
}

export const getCachedAuthSession = async (): Promise<AuthSession> => {
  if (isCacheValid()) return cachedSession!

  if (inflightRequest) return inflightRequest

  inflightRequest = amplifyFetchAuthSession({ forceRefresh: true })
    .then((session) => {
      cachedSession = session
      cachedAt = Date.now()
      return session
    })
    .finally(() => { inflightRequest = null })

  return inflightRequest
}

export const clearAuthSessionCache = () => {
  cachedSession = null
  cachedAt = 0
}
